export default () => {
  return <h1 className='text-center'>404</h1>;
};
